import { IServerResponse } from "app/interface";

export interface UserToBillState {
    userToBillList: Array<any> | null;
    saveUserToBillResp: IServerResponse;
    deleteUserToBillResp: IServerResponse;
}

export const initialState: UserToBillState = {
    userToBillList: null,
    saveUserToBillResp: null,
    deleteUserToBillResp: null
}
